module.exports = __webpack_public_path__ + "static/media/mantou_rock_sunset_latombe_overlayed.27375f24.jpg";